// extracted by mini-css-extract-plugin
export default {"f":"_41fca6e822","main":"dacd87881b","btn":"b4fb2ac329","w":"_9bf241f0e2","h":"_612f096475","lh25":"_07328568b3","wb":"_3b56e14b27","b":"d7bd751c09","bx":"_3b2e2588d6"};